import { useAuth } from "@/features/auth/contexts/AuthContext";
import { useCompanyProfile } from "@/hooks/useCompanyProfile";

/**
 * The tenant's active currency ISO code. `/company/profile` wins (it refetches after a settings
 * change); users without `company.read` get it from the auth user instead; defaults to "SAR".
 */
export function useCurrency(): string {
	const { user } = useAuth();
	const { data } = useCompanyProfile();
	return data?.currency?.trim() || user?.companyCurrency?.trim() || "SAR";
}

export default useCurrency;
